/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ICoordinate1 } from './Coordinate1';
import type { IMetroLine } from '../metro/MetroLine';

export interface IInfrastructureItemV4 {
  /** Тип объекта инфраструктуры **/
  type: EType;
  /** Название объекта **/
  title: string;
  /** Время пешком до объекта **/
  timeWalk: number;
  /** id **/
  id: string;
  coordinates: ICoordinate1;
  /** Дистанция от ЖК **/
  distance: string;
  /** Адрес **/
  address?: TInfrastructureItemV4_Address;
  /** Линия метро **/
  line?: TInfrastructureItemV4_Line;
  /** Отображаемое название типа инфраструктуры **/
  typeName?: TInfrastructureItemV4_TypeName;
  /** Вид инфраструктуры **/
  kind?: TInfrastructureItemV4_Kind;
  /** Отображаемое название вида инфраструктуры **/
  kindName?: TInfrastructureItemV4_KindName;
}

export enum EType {
  /** Кафе **/
  'Cafe' = 'cafe',
  /** Поликлиники **/
  'Clinic' = 'clinic',
  /** Продуктовые магазины **/
  'Grocery' = 'grocery',
  /** Детские сады **/
  'Nursery' = 'nursery',
  /** Школы **/
  'School' = 'school',
  /** Метро **/
  'Metro' = 'metro',
  /** Пляжи **/
  'Beaches' = 'beaches',
  /** Парки **/
  'Parks' = 'parks',
  /** Общий тип для парков и пляжей **/
  'RestAreas' = 'restAreas',
}
export type TInfrastructureItemV4_Address = null | string;

export type TInfrastructureItemV4_Line = null | IMetroLine;

export type TInfrastructureItemV4_TypeName = null | string;

export type TInfrastructureItemV4_Kind = null | EKind;

export enum EKind {
  /** Метро **/
  'Metro' = 'metro',
  /** МЦД **/
  'Mcd' = 'mcd',
  /** Пляжи **/
  'Beaches' = 'beaches',
  /** Парки **/
  'Parks' = 'parks',
}
export type TInfrastructureItemV4_KindName = null | string;
